<template>
    <div v-if="loaded">
        <div v-if="isOn">
            <nav class="my-2 px-2 inline-block md:hidden">
                <div class="relative">
                    <button
                        class="mx-1 p-2 bg-primary-lighter border-gray-dark border rounded text-primary"
                        @click.prevent="toggleFolders"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'folder-open']"
                        ></font-awesome-icon>
                        <span v-if="isActiveFolder('personal')">Important</span>
                        <span v-if="isActiveFolder('social')">Social</span>
                        <span v-if="isActiveFolder('promotions')"
                            >Promotions</span
                        >
                        <span v-if="isActiveFolder('updates')">Updates</span>
                        <span v-if="isActiveFolder('forums')">Forums</span>
                        <span v-if="isActiveFolder('all')">All</span>
                        <font-awesome-icon
                            :icon="['fas', 'caret-down']"
                            class="ml-2"
                        ></font-awesome-icon>
                    </button>
                    <div class="inline">
                        <span
                            class="text-xs p-1 rounded text-primary font-bold"
                            v-if="meta.counts[activeFolder] > 0"
                            >{{ meta.counts[activeFolder] }}</span
                        >
                        <span
                            class="text-xs p-1 rounded text-primary font-bold"
                            v-else
                            >👌</span
                        >
                    </div>
                    <button
                        v-if="isFoldersOpen"
                        @click.prevent="toggleFolders"
                        tabindex="-1"
                        class="fixed inset-0 h-full w-full cursor-default z-20"
                    ></button>
                    <div
                        class="block absolute left-0 top-0 border border-gray-dark py-2 w-48 bg-white rounded shadow-xl z-30"
                        :class="isFoldersOpen ? '' : 'hidden'"
                    >
                        <ul class="my-1">
                            <li
                                class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                                :class="
                                    isActiveFolder('all')
                                        ? 'bg-primary text-white font-bold'
                                        : ''
                                "
                                @click="setActiveFolder('all')"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'folder-open']"
                                    class="text-primary-lighter mr-2"
                                ></font-awesome-icon>
                                <span class="text-sm"
                                    >All
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-if="meta.counts.all > 0"
                                        >{{ meta.counts.all }}</span
                                    >
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-else
                                        >👌</span
                                    >
                                </span>
                            </li>
                            <li
                                class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                                :class="
                                    isActiveFolder('personal')
                                        ? 'bg-primary text-white font-bold'
                                        : ''
                                "
                                @click="setActiveFolder('personal')"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'folder-open']"
                                    class="text-primary-lighter mr-2"
                                ></font-awesome-icon>
                                <span class="text-sm"
                                    >Important
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-if="meta.counts.personal > 0"
                                        >{{ meta.counts.personal }}</span
                                    >
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-else
                                        >👌</span
                                    >
                                </span>
                            </li>
                            <li
                                class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                                :class="
                                    isActiveFolder('social')
                                        ? 'bg-primary text-white font-bold'
                                        : ''
                                "
                                @click="setActiveFolder('social')"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'folder-open']"
                                    class="text-primary-lighter mr-2"
                                ></font-awesome-icon>
                                <span class="text-sm"
                                    >Social
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-if="meta.counts.social > 0"
                                        >{{ meta.counts.social }}</span
                                    >
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-else
                                        >👌</span
                                    >
                                </span>
                            </li>
                            <li
                                class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                                :class="
                                    isActiveFolder('promotions')
                                        ? 'bg-primary text-white font-bold'
                                        : ''
                                "
                                @click="setActiveFolder('promotions')"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'folder-open']"
                                    class="text-primary-lighter mr-2"
                                ></font-awesome-icon>
                                <span class="text-sm"
                                    >Promotions
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-if="meta.counts.promotions > 0"
                                        >{{ meta.counts.promotions }}</span
                                    >
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-else
                                        >👌</span
                                    >
                                </span>
                            </li>
                            <li
                                class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                                :class="
                                    isActiveFolder('updates')
                                        ? 'bg-primary text-white font-bold'
                                        : ''
                                "
                                @click="setActiveFolder('updates')"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'folder-open']"
                                    class="text-primary-lighter mr-2"
                                ></font-awesome-icon>
                                <span class="text-sm"
                                    >Updates
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-if="meta.counts.updates > 0"
                                        >{{ meta.counts.updates }}</span
                                    >
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-else
                                        >👌</span
                                    >
                                </span>
                            </li>
                            <li
                                class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                                :class="
                                    isActiveFolder('forums')
                                        ? 'bg-primary text-white font-bold'
                                        : ''
                                "
                                @click="setActiveFolder('forums')"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'folder-open']"
                                    class="text-primary-lighter mr-2"
                                ></font-awesome-icon>
                                <span class="text-sm"
                                    >Forums
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-if="meta.counts.forums > 0"
                                        >{{ meta.counts.forums }}</span
                                    >
                                    <span
                                        class="text-xs bg-white p-1 rounded text-primary font-bold"
                                        v-else
                                        >👌</span
                                    >
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <div class="my-2 px-2 flex items-start" ref="expandPanel">
                <aside
                    class="hidden md:block md:w-1/4 sticky top-0 h-screen px-1 bg-gray-light border-gray-dark border rounded"
                >
                    <ul class="my-1">
                        <li
                            class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                            :class="
                                isActiveFolder('all')
                                    ? 'bg-primary text-white font-bold'
                                    : ''
                            "
                            @click="setActiveFolder('all')"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'folder-open']"
                                class="text-primary-lighter mr-2"
                            ></font-awesome-icon>
                            <span class="text-sm"
                                >All
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-if="meta.counts.all > 0"
                                    >{{ meta.counts.all }}</span
                                >
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-else
                                    >👌</span
                                >
                            </span>
                        </li>
                        <li
                            class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                            :class="
                                isActiveFolder('personal')
                                    ? 'bg-primary text-white font-bold'
                                    : ''
                            "
                            @click="setActiveFolder('personal')"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'folder-open']"
                                class="text-primary-lighter mr-2"
                            ></font-awesome-icon>
                            <span class="text-sm"
                                >Important
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-if="meta.counts.personal > 0"
                                    >{{ meta.counts.personal }}</span
                                >
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-else
                                    >👌</span
                                >
                            </span>
                        </li>
                        <li
                            class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                            :class="
                                isActiveFolder('social')
                                    ? 'bg-primary text-white font-bold'
                                    : ''
                            "
                            @click="setActiveFolder('social')"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'folder-open']"
                                class="text-primary-lighter mr-2"
                            ></font-awesome-icon>
                            <span class="text-sm"
                                >Social
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-if="meta.counts.social > 0"
                                    >{{ meta.counts.social }}</span
                                >
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-else
                                    >👌</span
                                >
                            </span>
                        </li>
                        <li
                            class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                            :class="
                                isActiveFolder('promotions')
                                    ? 'bg-primary text-white font-bold'
                                    : ''
                            "
                            @click="setActiveFolder('promotions')"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'folder-open']"
                                class="text-primary-lighter mr-2"
                            ></font-awesome-icon>
                            <span class="text-sm"
                                >Promotions
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-if="meta.counts.promotions > 0"
                                    >{{ meta.counts.promotions }}</span
                                >
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-else
                                    >👌</span
                                >
                            </span>
                        </li>
                        <li
                            class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                            :class="
                                isActiveFolder('updates')
                                    ? 'bg-primary text-white font-bold'
                                    : ''
                            "
                            @click="setActiveFolder('updates')"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'folder-open']"
                                class="text-primary-lighter mr-2"
                            ></font-awesome-icon>
                            <span class="text-sm"
                                >Updates
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-if="meta.counts.updates > 0"
                                    >{{ meta.counts.updates }}</span
                                >
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-else
                                    >👌</span
                                >
                            </span>
                        </li>
                        <li
                            class="my-1 p-4 hover:bg-primary hover:text-white rounded cursor-pointer"
                            :class="
                                isActiveFolder('forums')
                                    ? 'bg-primary text-white font-bold'
                                    : ''
                            "
                            @click="setActiveFolder('forums')"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'folder-open']"
                                class="text-primary-lighter mr-2"
                            ></font-awesome-icon>
                            <span class="text-sm"
                                >Forums
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-if="meta.counts.forums > 0"
                                    >{{ meta.counts.forums }}</span
                                >
                                <span
                                    class="text-xs bg-white p-1 rounded text-primary font-bold"
                                    v-else
                                    >👌</span
                                >
                            </span>
                        </li>
                    </ul>
                </aside>
                <div
                    class="w-full md:w-3/4 px-1 rounded"
                    v-if="activeMessage === null"
                >
                    <div v-if="pagination.items_total === 0">
                        <div class="mt-16 p-8 text-center">
                            <p>
                                <strong>🎉 Yay! Nothing here to review.</strong>
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <nav
                            class="text-sm sticky top-0 z-10 border-gray-dark border bg-gray-light rounded"
                        >
                            <div
                                class="p-2 rounded flex items-center justify-between"
                            >
                                <p-check
                                    name="check"
                                    color="primary"
                                    class="p-curve p-icon p-thick"
                                    @change="handleParentCheckbox"
                                    v-model="parentCheckbox"
                                >
                                    <font-awesome-icon
                                        :icon="['fas', checkboxIcon]"
                                        slot="extra"
                                        class="icon"
                                    ></font-awesome-icon>
                                </p-check>
                                <div
                                    v-if="parentCheckbox"
                                    class="flex items-center"
                                >
                                    <button
                                        @click.prevent="ignoreSelected"
                                        class="font-bold text-primary mx-2"
                                        :class="
                                            !parentCheckbox
                                                ? 'opacity-50 cursor-default'
                                                : ''
                                        "
                                        :disabled="!parentCheckbox"
                                    >
                                        Mark as reviewed
                                    </button>
                                    <reviewer-review-actions
                                        :collapsible="false"
                                        :messages="selectedMessages"
                                        @inspected="markInspected($event)"
                                    ></reviewer-review-actions>
                                </div>
                                <div v-else>
                                    <button
                                        @click.prevent="ignoreAll"
                                        class="font-bold text-primary text-sm px-2 py-1 rounded"
                                    >
                                        Mark all as reviewed
                                    </button>
                                </div>
                            </div>
                        </nav>

                        <section class="mt-2 text-sm">
                            <div class="my-2 p-1 bg-primary-lighter rounded">
                                <p class="italic text-center text-primary">
                                    <font-awesome-icon
                                        :icon="['far', 'lightbulb']"
                                    ></font-awesome-icon>
                                    Clicking on the subject lines will reveal
                                    full email body and more options.
                                </p>
                            </div>
                            <div
                                v-for="message in messages"
                                :key="message.id"
                                class="p-2 border-b border-gray-dark hover:bg-gray-light flex items-center justify-between message-list-item"
                            >
                                <div class="min-w-0">
                                    <header class="flex justify-between">
                                        <div class="flex items-center min-w-0">
                                            <p-check
                                                name="check"
                                                color="primary"
                                                class="p-curve p-icon p-thick"
                                                @change="handleGroupCheckbox()"
                                                v-model="selected[message.id]"
                                            >
                                                <font-awesome-icon
                                                    :icon="['fas', 'check']"
                                                    slot="extra"
                                                    class="icon"
                                                ></font-awesome-icon>
                                            </p-check>
                                            <p class="font-bold truncate ml-1">
                                                <span
                                                    class="hidden md:inline"
                                                    >{{
                                                        message.from_name
                                                    }}</span
                                                >
                                                <span
                                                    class="md:text-gray-darker truncate md:font-extralight"
                                                    >{{ message.from_address }}
                                                </span>
                                            </p>
                                        </div>
                                    </header>

                                    <section class="ml-6 py-1">
                                        <p
                                            class="truncate cursor-pointer hover:underline"
                                        >
                                            <a
                                                href
                                                @click.prevent="
                                                    setActiveMessage(message)
                                                "
                                                >{{ message.subject }}</a
                                            >
                                        </p>
                                    </section>
                                </div>
                                <!-- <div class="flex-shrink-0 hidden message-list-item-actions"> -->
                                <reviewer-review-actions
                                    :messages="[message]"
                                    @inspected="markInspected($event)"
                                ></reviewer-review-actions>
                                <!-- </div> -->
                            </div>
                        </section>
                    </div>
                </div>
                <div class="w-full md:w-3/4 px-1 rounded" v-else>
                    <nav
                        class="text-sm sticky top-0 z-10 border-gray-dark border bg-gray-light rounded"
                    >
                        <div
                            class="p-2 rounded flex items-center justify-between"
                        >
                            <button
                                @click.prevent="goBackFromActiveMessage(true)"
                                class="text-primary text-sm px-2 py-1 rounded"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'arrow-left']"
                                ></font-awesome-icon>
                            </button>
                            <div class="flex items-center">
                                <button
                                    @click.prevent="makeVip"
                                    class="font-bold text-primary"
                                >
                                    Make VIP
                                </button>
                                <span class="mx-1 text-gray-darker">·</span>
                                <button
                                    @click.prevent="
                                        goBackFromActiveMessage(false)
                                    "
                                    class="font-bold text-primary"
                                >
                                    Mark as reviewed
                                </button>
                                <!-- <button @click.prevent="deliver(activeMessage.id)" class="font-bold text-primary">
                                Allow once
                            </button> -->
                                <span class="mx-1"></span>
                                <reviewer-review-actions
                                    :collapsible="false"
                                    :messages="[activeMessage]"
                                    @inspected="
                                        markInspected($event, () => {
                                            activeMessage = null;
                                        })
                                    "
                                ></reviewer-review-actions>
                            </div>
                        </div>
                    </nav>

                    <section class="mt-2 text-sm">
                        <div class="p-2">
                            <header class="flex justify-between min-w-0">
                                <p class="font-bold truncate">
                                    <span class="hidden md:inline">{{
                                        activeMessage.from_name
                                    }}</span>
                                    <span
                                        class="md:text-gray-darker truncate md:font-extralight"
                                        >{{ activeMessage.from_address }}
                                    </span>
                                </p>
                                <p class="font-extralight text-gray-darker">
                                    {{ activeMessage.received_at }}
                                </p>
                            </header>

                            <section class="py-1">
                                <p class="font-bold text-base">
                                    {{ activeMessage.subject }}
                                </p>

                                <div class="mt-4">
                                    <iframe
                                        :srcdoc="activeMessage.body_html"
                                        class="w-full h-screen"
                                        v-if="activeMessage.body_html !== null"
                                    ></iframe>
                                    <pre
                                        class="w-full h-screen"
                                        v-else-if="
                                            activeMessage.body_text !== null
                                        "
                                    >
                                    {{ activeMessage.body_text }}
                                </pre
                                    >
                                    <pre class="w-full h-screen" v-else>
                                    {{ activeMessage.snippet }}
                                </pre
                                    >
                                </div>
                            </section>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <div class="my-4 pb-16 text-center" v-else>
            <img
                src="/images/empty-state.svg"
                alt="No Teams Found"
                class="mx-auto"
            />
            <p class="mx-8 xl:mx-64 my-16 font-bold text-primary">
                Daily Digest holds back all emails that come from people you
                have never emailed before. Then, once a day, you review them to
                get only valuable emails in your inbox. Get started by
                activating Daily Digest.
            </p>
            <a
                href
                @click.prevent="toggleFilterStatus(true)"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                >Activate Daily Digest</a
            >
        </div>
    </div>
    <div v-else></div>
</template>

<script>
import IgnoreConfirmationModal from "./IgnoreConfirmationModal";
import ReviewerReviewActions from "./ReviewerReviewActions.vue";
import VipConfirmationModal from "./VipConfirmationModal.vue";

export default {
    components: { ReviewerReviewActions },
    data() {
        return {
            loaded: false,
            meta: { counts: {} },
            activeFolder: "all",
            activeMessage: null,
            messages: [],
            pagination: {},
            selected: {},
            parentCheckbox: false,
            highlightedGroupIndex: 0,
            isInShortcutMode: false,
            isOn: true,
            isFoldersOpen: false,

            listScrollPosition: 0,
        };
    },
    mounted() {
        axios
            .get("/api/mailbox")
            .then((response) => {
                this.isOn = response.data.data.is_filtering_spam;
            })
            .catch((err) => console.error);
        this.onPage(1);
        this.handleScroll();
    },
    computed: {
        activeFolderCategoryId() {
            if (!this.activeFolder || this.activeFolder === "all") return null;

            return `category_${this.activeFolder}`.toUpperCase();
        },
        selectedGroups() {
            let selected = {},
                group;

            for (group in this.selected) {
                if (
                    this.selected.hasOwnProperty(group) &&
                    this.selected[group] === true
                ) {
                    selected[group] = this.selected[group];
                }
            }

            return selected;
        },
        selectedMessages() {
            let messages = [];
            for (const group in this.selectedGroups) {
                if (this.selectedGroups.hasOwnProperty(group)) {
                    if (
                        this.selectedGroups[group] &&
                        this.messagesBySender[group]
                    ) {
                        this.messagesBySender[group].forEach((message) => {
                            messages.push(message);
                        });
                    }
                }
            }

            return messages;
        },
        checkboxState() {
            let selectedLength = Object.keys(this.selectedGroups).length;
            let groupedLength = Object.keys(this.messagesBySender).length;

            if (selectedLength === 0) return "none";
            if (selectedLength === groupedLength) return "all";
            return "some";
        },
        checkboxIcon() {
            switch (this.checkboxState) {
                case "all":
                    return "check";
                default:
                    return "minus";
            }
        },
        messagesBySender() {
            return this.messages.reduce((acc, message) => {
                (acc[message.id] = acc[message.id] || []).push(message);
                return acc;
            }, {});
        },
        highlightedGroupName() {
            let groups = Object.keys(this.messagesBySender);

            // wrap around to zero index, is index not found
            if (!groups[this.highlightedGroupIndex])
                this.highlightedGroupIndex = 0;

            return groups[this.highlightedGroupIndex];
        },
    },
    methods: {
        toggleFolders() {
            this.isFoldersOpen = !this.isFoldersOpen;
        },
        setActiveMessage(message) {
            this.activeMessage = message;

            this.listScrollPosition = document.documentElement.scrollTop;
            this.$refs.expandPanel.scrollIntoView();

            axios
                .get(`/api/messages/${message.id}?full`)
                .then((response) => {
                    // if the active message is still active
                    if (this.activeMessage) {
                        this.activeMessage = response.data.data;
                    }
                })
                .catch((err) => console.error);
        },
        resetActiveMessage() {
            this.activeMessage = null;
            setTimeout(() => {
                document.documentElement.scrollTop = this.listScrollPosition;
            }, 100);
        },
        setActiveFolder(folder) {
            this.activeFolder = folder;

            this.isFoldersOpen = false;

            this.onPage(1);
            this.resetActiveMessage();
            this.unselectAll();
        },
        goBackFromActiveMessage(keepUnreviewed = false) {
            // if to keep unreviewed
            if (keepUnreviewed) return this.resetActiveMessage();

            // if to mark as reviewed
            this.markInspected(
                {
                    ids: [this.activeMessage.id],
                    action: "ignore",
                },
                () => {
                    this.resetActiveMessage();
                }
            );
        },
        isActiveFolder(folder) {
            return this.activeFolder === folder;
        },
        handleScroll() {
            window.onscroll = () => {
                let bottomOfWindow =
                    document.documentElement.scrollTop + window.innerHeight >=
                    document.documentElement.offsetHeight;

                if (bottomOfWindow) this.getNextPage();
            };
        },
        refreshMessagesMeta() {
            axios
                .get("/api/messages/meta")
                .then((response) => (this.meta = response.data.data))
                .catch((err) => console.error);
        },
        getNextPage() {
            // if no more pages, exit early
            if (
                !this.pagination.current ||
                this.pagination.current >= this.pagination.total
            )
                return;

            let endpoint = `/api/messages?page=${this.pagination.current + 1}`;
            if (this.activeFolderCategoryId)
                endpoint += `&category_id=${this.activeFolderCategoryId}`;

            axios
                .get(endpoint)
                .then((response) => {
                    this.messages = this.messages.concat(response.data.data);
                    this.setPagination(response);
                    this.loaded = true;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        onPage(page) {
            let endpoint = `/api/messages?page=${page}`;
            if (this.activeFolderCategoryId)
                endpoint += `&category_id=${this.activeFolderCategoryId}`;

            axios
                .get(endpoint)
                .then((response) => {
                    this.messages = response.data.data;
                    this.setPagination(response);
                    this.loaded = true;
                    this.refreshMessagesMeta();
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        setPagination(response) {
            this.pagination = {
                current: response.data.meta.current_page,
                total: response.data.meta.last_page,
                items_total: response.data.meta.total,
            };
        },
        getToastText(action) {
            switch (action) {
                case "immediate":
                    return "Great! Emails like this will be delivered immediately.";
                case "deny":
                    return 'Great! Emails like this will be delivered to the "Blocked" folder.';
                case "allow":
                    return "Great! Emails like this will continue to be delivered.";
                case "once":
                    return "Great! This thread is delivered to your inbox now.";
                case "ignore":
                    return "Successfully marked as reviewed.";
                case "spell":
                    return "Great! Emails like this will be handled by a magic spell.";
            }
        },
        markInspected(inspection, callback) {
            let current = this.messages;
            this.messages = this.messages.filter((message) => {
                return inspection.ids.indexOf(message.id) === -1;
            });
            Event.$emit("toast", {
                text: this.getToastText(inspection.action),
            });

            // do not unselect when a single message is inspected.
            // we need to forcefully unselect in rest of the cases,
            // to properly handle the state of parent checkbox.
            if (inspection.ids.length > 1) this.unselectAll();

            axios
                .put("/api/messages", {
                    ids: inspection.ids,
                    action: inspection.action,
                })
                .then(() => {
                    if (callback) callback();
                    this.onPage(1);
                })
                .catch((err) => {
                    this.messages = current;
                    console.error(err);
                });
        },
        ignore(ids, callback) {
            Modal.show(IgnoreConfirmationModal)
                .then((response) => {
                    this.markInspected(
                        {
                            ids: ids,
                            action: "ignore",
                        },
                        callback
                    );
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        makeVip() {
            Modal.show(VipConfirmationModal)
                .then((response) => {
                    axios
                        .post(`/api/intents`, {
                            type: "address",
                            values: [this.activeMessage.from_address],
                            action: "immediate",
                            spell: null,
                        })
                        .then(() => {
                            this.markInspected(
                                {
                                    ids: [this.activeMessage.id],
                                    action: "immediate",
                                },
                                () => {
                                    this.resetActiveMessage();
                                }
                            );
                        })
                        .catch((err) => console.error);
                })
                .catch((err) => console.error);
        },
        deliver(id) {
            axios
                .post(`/api/messages/${id}/deliveries`)
                .then((err) => {
                    this.markInspected(
                        {
                            ids: [id],
                            action: "once",
                        },
                        () => {
                            this.resetActiveMessage();
                        }
                    );
                })
                .catch((err) => console.log);
        },
        ignoreAll() {
            let selectedIds = this.messages.map((message) => message.id);
            if (selectedIds.length < 1) return;

            this.ignore(selectedIds, () => {
                this.unselectAll();
            });
        },
        ignoreSelected() {
            let selectedIds = this.selectedMessages.map(
                (message) => message.id
            );
            if (selectedIds.length < 1) return;

            this.ignore(selectedIds, () => {
                this.unselectAll();
            });
        },
        ignoreActive() {
            if (!this.activeMessage) return;

            this.ignore([this.activeMessage.id], () => {
                this.resetActiveMessage();
            });
        },
        handleGroupCheckbox() {
            // if any group is selected, mark the parent checkbox to be selected
            if (Object.keys(this.selectedGroups).length > 0) {
                this.parentCheckbox = true;
            } else {
                this.parentCheckbox = false;
            }
        },
        handleParentCheckbox() {
            if (!this.parentCheckbox) {
                // if deselected, unselect all the messages
                this.unselectAll();
                return;
            }
            switch (this.checkboxState) {
                case "none":
                    for (const sender in this.messagesBySender) {
                        this.$set(this.selected, sender, true);
                    }
                    break;

                default:
                    break;
            }
        },
        unselectAll() {
            this.selected = {};
            for (let sender in this.messagesBySender) {
                if (this.messagesBySender.hasOwnProperty(sender)) {
                    this.$set(this.selected, sender, false);
                }
            }
            this.parentCheckbox = false;
        },
        toggleFilterStatus(isOn) {
            axios
                .put("/api/mailbox", {
                    is_filtering_spam: isOn,
                })
                .then((response) => {
                    const message = isOn
                        ? "Great! Spammy emails will be held back for your review."
                        : "Great! All emails will be delivered to your inbox.";
                    Event.$emit("toast", { text: message });
                    this.isOn = isOn;
                })
                .catch((err) => {
                    if (err.response.data?.message) {
                        this.isOn = !this.isOn;
                        Event.$emit("toast", {
                            text: err.response.data?.message,
                            type: "danger",
                        });
                    }
                    console.error(err);
                });
        },
    },
};
</script>

<style lang="scss">
.message-list-item {
    &:hover .message-list-item-actions {
        display: inline-block;
    }
}

pre {
    overflow-x: auto;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
}
</style>
